import { IFaceLoader } from '@/bo-kit/components';
import { UserType } from '@/bo-kit/types';
import { AUTH_ROUTES } from '@/routes/consts';
import { useGetUserProfileQuery } from '@/transport/gatewayApi/index';
import { getCCUrl, getMCUrl } from '@/ui-kit/utils';
import { FC, ReactNode, Suspense, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const AuthGuard: FC<{
    children?: ReactNode;
}> = ({ children }) => {
    const { data, isSuccess, isError, isLoading, isUninitialized } = useGetUserProfileQuery();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const isAuthRoute = AUTH_ROUTES.some((route) => pathname.includes(route)) || pathname === '/';
    const [showLoader, setShowLoader] = useState(isLoading || isUninitialized);

    // const { pathname: _pathname } = useLocation();
    // const pathname = BASE_PATH + _pathname;
    // const isAuthRoute =
    //     AUTH_ROUTES.some((route) => pathname.includes(route)) && pathname !== '/auth/logout';

    useEffect(() => {
        if (isError && !isAuthRoute) navigate('/');
    }, [isAuthRoute, isError, navigate]);

    useEffect(() => {
        if (isSuccess && isAuthRoute && data) {
            const userType = data.type;

            if ([UserType.Customer, UserType.CustomerLegal].includes(userType)) {
                window.location.href = getCCUrl();
            } else if ([UserType.MerchantIssuer, UserType.Merchant].includes(userType)) {
                window.location.href = getMCUrl();
            }
        }
    }, [isAuthRoute, isSuccess, data]);

    useEffect(() => {
        if (isLoading || isUninitialized) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }
    }, [isLoading, isUninitialized]);

    if (showLoader) {
        return <IFaceLoader />;
    }

    // if (isError) {
    //     return <Navigate to='/auth' replace />;
    // }
    // if (isSuccess && isAuthRoute) {
    //     return <Navigate to='/' replace />;
    // }
    return <Suspense fallback={<IFaceLoader />}>{children}</Suspense>;
};
